import { SchmancyElement } from '@schmancy/mixins/index'
import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('schmancy-card-header')
export default class SchmancyCardHeader extends SchmancyElement {
	static styles = [
		css`
			:host {
				display: block;
			}
		`,
	]
	protected render(): unknown {
		return html`
			<div class="flex items-center justify-between gap-2 p-4 border-b border-outline-variant">
				<slot name="title"></slot>
				<slot name="actions"></slot>
			</div>
		`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-card-header': SchmancyCardHeader
	}
}
